import { render, staticRenderFns } from "./HealthInfo.vue?vue&type=template&id=fd89fd3c"
import script from "./HealthInfo.vue?vue&type=script&lang=js"
export * from "./HealthInfo.vue?vue&type=script&lang=js"
import style0 from "./HealthInfo.vue?vue&type=style&index=0&id=fd89fd3c&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd89fd3c')) {
      api.createRecord('fd89fd3c', component.options)
    } else {
      api.reload('fd89fd3c', component.options)
    }
    module.hot.accept("./HealthInfo.vue?vue&type=template&id=fd89fd3c", function () {
      api.rerender('fd89fd3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/health/HealthInfo.vue"
export default component.exports